export const katakanaRegexp = /^[ァ-ンーヴヷヺ]+$/;
export const mobilePhoneRegexp =
  /^0[789]0[0-9]{8}$|^(0[789]0)-[0-9]{4}-[0-9]{4}$/;
export const numberOrHyphenRegexp = /^[0-9０-９-‐−ー―ｰ－]+$/;
export const timeRegexp = /^(([01][0-9]|2[0-3]):[0-5]{1}[0-9]{1}|24:00)$/;
